module.exports = __webpack_public_path__ + "static/media/nc2.e55b4d09.png";